import { ReactElement } from 'react';

import { AppointmentReceptionService } from '@dreryk/egabinet-appointment-frontend-api';
import { ReceptionService } from '@dreryk/egabinet-waitlist-frontend-api';

import { StyledFlex, TextView } from '@dreryk/react-components';
import { createSingleInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { IncompatiblePreferenceNotification } from './IncompatiblePreferenceNotification';

type ReceptionServiceTextViewProps = {
   appointmentReceptionServices: AppointmentReceptionService[];
   receptionService: ReceptionService | undefined;
};

export const ReceptionServiceTextView = (props: ReceptionServiceTextViewProps): ReactElement => {
   const shouldShowNotification = Boolean(
      props.appointmentReceptionServices &&
         props.receptionService &&
         !props.appointmentReceptionServices.some(
            (service) => service.receptionServiceId === props.receptionService!.id.asNumber()
         )
   );

   return (
      <TextView testId={'receptionService'} label={translationKeys.receptionServices}>
         <StyledFlex direction={'column'} gap={'8px'}>
            {props.appointmentReceptionServices.length ? (
               props.appointmentReceptionServices.map((service) => service.name).join(', ')
            ) : (
               <Translate>{translationKeys.notSelected}</Translate>
            )}
            {shouldShowNotification && props.receptionService ? (
               <IncompatiblePreferenceNotification
                  warning
                  testId={'receptionServicePreference'}
                  label={createSingleInterpolatedTranslationKey(
                     translationKeys.preference,
                     'label',
                     props.receptionService.name
                  )}
               />
            ) : null}
         </StyledFlex>
      </TextView>
   );
};
